import React from "react";
import PropTypes from "prop-types";
import {
  IconButton,
  Tooltip,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";

function ChangeStatusWithDialog(props) {
  //const isActiveBoolean = props.isActive == 1;
  console.log("isActive", props.isActive);
  const [isActive, setIsActive] = React.useState(props.isActive);

  const isActiveBoolean = props.isActive == 1 ? true : false;
  const [state, setState] = React.useState({
    checkedB: isActiveBoolean,
  });
  // const [state, setState] = React.useState({ checkedB: isActiveBoolean });

  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [pendingChecked, setPendingChecked] = React.useState(isActiveBoolean);

  const handleSwitchClick = (event) => {
    
    // Save the intended change but wait for confirmation
    setPendingChecked(event.target.checked);
    setDialogOpen(true);
  };

  const handleDialogClose = (confirmed) => {
    setDialogOpen(false);
    if (confirmed) {
      const newValue = pendingChecked ? 1 : 3;
      document.getElementById("isActiveInput").value = newValue;
      setState({ ...state, checkedB: pendingChecked });
      setIsActive(pendingChecked);

      props.handleChangeStatus(props.recordId, newValue).catch((error) => {
       
        console.error("Error changing status:", error);
      });
    }
  };

  return (
    <div>
      <form id={"myform" + props.recordId} autoComplete="off">
        <input type="hidden" value={props.recordId} name="id" />
        <input
          type="hidden"
          id="isActiveInput"
          value={isActive ? 1 : 3}
          name="isActive"
        />
      </form>

      <Tooltip title="Status">
        <Switch
          checked={state.checkedB}
          onChange={handleSwitchClick}
          disabled={props.primaryButtonDisabled}
          color="primary"
          name="checkedB"
          inputProps={{ "aria-label": "primary checkbox" }}
        />
      </Tooltip>

      <Tooltip title="Edit">
        <IconButton
          disabled={props.secondaryButtonDisabled}
          onClick={() => (window.location = `${props.onEditURL}`)}
        >
          <EditIcon fontSize="small" style={{ color: "#ff9800" }} />
        </IconButton>
      </Tooltip>

      {/* Confirmation Dialog */}
      <Dialog open={dialogOpen} onClose={() => handleDialogClose(false)}>
        <DialogTitle>{props.dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText>{props.dialogText}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleDialogClose(false)} color="default">
            No
          </Button>
          <Button onClick={() => handleDialogClose(true)} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

ChangeStatusWithDialog.propTypes = {
  primaryButtonDisabled: PropTypes.bool,
  secondaryButtonDisabled: PropTypes.bool,
  onEditURL: PropTypes.string,
  recordId: PropTypes.any,
  isActive: PropTypes.any,
  handleChangeStatus: PropTypes.func,
  dialogTitle: PropTypes.string,
  dialogText: PropTypes.string,
};

ChangeStatusWithDialog.defaultProps = {
  primaryButtonDisabled: false,
  secondaryButtonDisabled: false,
  onEditURL: "",
  recordId: "",
  isActive: "",
  handleChangeStatus: () => {},
  dialogTitle: "Change Status",
  dialogText: "Are you sure you want to change the status? This will deactivate the current general discount!",
};

export default ChangeStatusWithDialog;
